import React, { useEffect, useState } from "react";
import Topbar from "../../components/Topbar";
import Leftbar from "../../components/Leftsidebar";
import { Link } from "react-router-dom";
import "./updatepassword.css";
import { fcmUsers, handleUpdatepassword, sendNoti, showToast, uploadImage } from "../Utils/utils"
import Loaderspinner from "../../components/Loader";
import MultiSelectDropdown from "./MultiselectDropdown";
import { Modal } from "react-bootstrap";

const SendNotification = () => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false)
  const [showSidebar, setShowSidebar] = useState(false);
  const [users, setUsers] = useState([]);
  const [selected, setSelected] = useState([]);
  const [imageUrl, setImageUrl] = useState("");
  const [uploading, setUploading] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const handleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  const handleSidebarClose = () => {
    setShowSidebar(false);
  };

  const onSend = async (e) => {
    e.preventDefault();
    try {
      setLoading(true)
      let response = await sendNoti({
        userids: selected,
        title: title,
        body: description,
        image_url: imageUrl,
      });
      // console.log(response, "response.....")
      showToast(response.message, "success");
      setTimeout(() => {
        window.location.href = '/notification';
      }, [1000])

    } catch (error) {
      console.log(error, "error...");
      setLoading(false)
      showToast(error.message)
      setLoading(false)
    } finally {
      setLoading(false)
    }
  };

  const getfcmUsers = async () => {
    var temp = []
    var res = await fcmUsers()
    if (res.data && res.data.length > 0) {
      res.data.map((a) => {
        temp.push({
          id: a.userid, name: `${a.name} ${a.lastname} (${a.email})`, type: a.usertype
        })
      })
    }
    setUsers(temp)

  }

  useEffect(() => {
    getfcmUsers()
  }, [])

  const handleImageUpload = async (file) => {
    try {
      setUploading(true);

      const formData = new FormData();
      formData.append("file", file);

      // 🔴 CHANGE THIS API URL


      let res = await uploadImage(formData);
      if (res?.data) {
        setImageUrl(res?.data); // ✅ auto-fill input
        showToast("Image uploaded successfully", "success");
      } else {
        showToast("Image upload failed");
      }
    } catch (err) {
      console.error(err);
      showToast("Upload failed");
    } finally {
      setUploading(false);
    }
  };

  const onFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      handleImageUpload(file);
    }
  };

  const selectedUsers = users.filter(user => selected.includes(user.id));

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  return (
    <>
      {loading && <Loaderspinner />}
      <div class="g-sidenav-show  bg-gray-100 min-vh-100">
        <div id="wrapper">
          <Leftbar showSidebar={showSidebar}
            handleSidebarClose={handleSidebarClose} />
          <main className="main-content border-radius-lg">
            <Topbar handleSidebar={handleSidebar} />
            <div>
              <div className="header header-bg pb-6">
                <div className="container-fluid">
                  <div className="header-body">
                    <div className="row align-items-center py-4">
                      <div className="col-lg-6 col-7">
                        <nav
                          aria-label="breadcrumb"
                          className="d-none d-md-inline-block ml-md-4"
                        >
                          <ol className="breadcrumb breadcrumb-links breadcrumb-dark" style={{ background: "transparent" }}>
                            <li className="breadcrumb-item">
                              <Link to="/dashboard">
                                <i className="fas fa-home" />
                              </Link>
                            </li>
                            <li className="breadcrumb-item">
                              <Link to="/update-password"><span className="" style={{ color: " #f6f9fc", fontSize: "15px", textDecoration: "none" }}>Send Notification</span></Link>
                            </li>
                          </ol>
                        </nav>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="container-fluid mt--6">
                <div className="row">
                  <div className="col">
                    <form className="card mb-4" onSubmit={onSend}>
                      <div className="card-header">
                        <h5 className="mb-0">Send Notification</h5>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label className="form-control-label">
                                Title
                              </label>
                              <div style={{ height: "52px" }}>
                                <input
                                  // type="password"
                                  style={{ height: "100%" }}
                                  className="form-control"
                                  placeholder="Title"
                                  onChange={(e) =>
                                    setTitle(e.target.value)
                                  }
                                  value={title}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label className="form-control-label">
                                Users
                              </label>
                              <MultiSelectDropdown options={users}
                                setSelected={setSelected}
                                selected={selected}
                              />
                            </div>
                            {selected.length > 0 &&
                              <div className="row mt-1">
                                <div className="col-md-6">
                                  <button
                                    type="button"
                                    className="btn btn-outline-primary btn-sm mt-2"
                                    onClick={handleShow}
                                    disabled={!selected.length}
                                  >
                                    View Selected Users ({selected.length})
                                  </button>
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div className="col-md-12">
                            <div className="form-group">
                              <label className="form-control-label">
                                Description
                              </label>
                              <textarea className="form-control" placeholder="Description" name="Description"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)} rows={4} cols={40} />

                            </div>
                          </div>
                        </div>

                        <div className="row mt-2">
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="form-control-label">
                                Upload image or Image URL
                              </label>

                              <div className="d-flex gap-2">
                                {/* Image URL input */}
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Paste image URL here"
                                  value={imageUrl}
                                  onChange={(e) => setImageUrl(e.target.value)}
                                />

                                {/* Browse button */}
                                <label className="btn btn-outline-primary mb-0">
                                  {uploading ? "Uploading..." : "Browse"}
                                  <input
                                    type="file"
                                    accept="image/*"
                                    hidden
                                    onChange={onFileChange}
                                  />
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>



                        <button
                          className="btn submit-btn mt-4"
                          type="submit"
                        >
                          {" "}
                          <i className="far fa-paper-plane" /> Send{" "}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
      <Modal
        show={showModal}
        onHide={handleClose}
        centered
        size="md"
      >
        <Modal.Header closeButton>
          <Modal.Title>Selected Users ({selectedUsers.length})</Modal.Title>
        </Modal.Header>

        <Modal.Body
          style={{
            maxHeight: "400px",
            overflowY: "auto",
            padding: "10px 16px",
          }}
        >
          {selectedUsers.length > 0 ? (
            <div className="d-grid gap-2">
              {selectedUsers.map((user) => (
                <div
                  key={user.id}
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr auto",
                    alignItems: "center",
                    padding: "10px 12px",
                    border: "1px solid #eee",
                    borderRadius: "8px",
                    background: "#fff",
                  }}
                >
                  <div style={{ overflow: "hidden" }}>
                    <span
                      style={{
                        display: "block",
                        fontWeight: 500,
                        fontSize: "14px",
                        color: "#333",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {user.name}
                    </span>
                  </div>

                  <span
                    style={{
                      fontSize: "12px",
                      padding: "4px 8px",
                      borderRadius: "12px",
                      background: "#6c757d",
                      color: "#fff",
                      textTransform: "capitalize",
                    }}
                  >
                    {user.type == "deal" ? 'Lender' : 'Borrower'}
                  </span>
                </div>
              ))}
            </div>
          ) : (
            <div
              style={{
                textAlign: "center",
                color: "#999",
                padding: "20px",
              }}
            >
              No users selected
            </div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <button
            className="btn btn-secondary"
            onClick={handleClose}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SendNotification;
